// extracted by mini-css-extract-plugin
export var compact = "_my-2";
export var phoneFrame = "_my-0";
export var phoneScreen = "_my-1";